// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"4cd45da9","265":"9c0e493c","518":"18ac9c3d","670":"520c4ce1","907":"5ef448b8","969":"fca5bac0","995":"46b8f5ff"}[chunkId] + ".chunk.js";
};